// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\doctors\EditDoctorPage\index.js

import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { getPersonById, updatePerson } from "../../../redux/slices/persons/personsThunk";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};
const tailLayout = {
  wrapperCol: { offset: 12, span: 12, gutter: 10 },
};

const EditDoctorPage = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const [oldDoc, setOldDoc] = useState({});

  useEffect(() => {
    dispatch(getPersonById(id)).then(({ payload }) => {
      if (!payload) return;

      const { 
        firstname, lastname, email, phoneNumber, address, 
        government, region, doctor, potential, isPartner, partnerNotes,
        latitude, longitude, relationshipCategory
      } = payload;
      
      setOldDoc({
        government: government?.id,
        region: region?.id,
        specialty: doctor?.specialty?.id,
        doctorType: doctor?.doctorType,
      });

      // Déduction de la catégorie par défaut
      const defaultCategory = relationshipCategory || (isPartner ? 'PARTNER_ACTIVE' : 'STANDARD');

      form.setFieldsValue({
        firstname,
        lastname,
        specialty: doctor?.specialty?.name,
        email,
        phone: phoneNumber,
        address,
        latitude: latitude || "",
        longitude: longitude || "",
        region: region?.name,
        government: government?.name,
        potential,
        isPartner: isPartner || false,
        relationshipCategory: defaultCategory,
        partnerNotes: partnerNotes || "",
        doctorType: (doctor?.doctorType !== null && doctor?.doctorType !== undefined) 
          ? Number(doctor.doctorType) 
          : undefined, 
      });
    });
  }, [dispatch, id, form]);

  const handleAddPartnerNote = () => {
    const input = document.getElementById('newPartnerNoteInput');
    const noteText = input?.value?.trim();
    
    if (!noteText) {
      return toast.warning("Veuillez saisir un texte avant d'ajouter.");
    }

    const currentNotes = form.getFieldValue('partnerNotes') || "";
    const date = dayjs().format('DD/MM/YYYY');
    const newEntry = `${date} : ${noteText}`;
    const updatedNotes = currentNotes ? `${newEntry}\n${currentNotes}` : newEntry;

    form.setFieldsValue({ partnerNotes: updatedNotes });
    if (input) input.value = "";
  };

  const handleDeletePartnerNote = (indexToDelete) => {
    const currentNotes = form.getFieldValue('partnerNotes') || "";
    const notesArray = currentNotes.split('\n').filter(Boolean);
    const updatedArray = notesArray.filter((_, i) => i !== indexToDelete);
    
    form.setFieldsValue({ partnerNotes: updatedArray.join('\n') });
    toast.info("Note retirée de la liste locale.");
  };

  const onFinish = (values) => {
    const parseCoord = (val) => {
      if (!val || String(val).trim() === "") return null;
      const clean = String(val).replace(",", ".").trim();
      const num = parseFloat(clean);
      return isNaN(num) ? null : num;
    };

    // Synchronisation automatique de isPartner
    const isPartnerFlag = (values.relationshipCategory === 'PARTNER_ACTIVE' || values.relationshipCategory === 'PARTNER_AT_RISK');

    const formattedValues = {
      firstname: values.firstname,
      lastname: values.lastname,
      potential: values.potential,
      relationshipCategory: values.relationshipCategory,
      isPartner: isPartnerFlag,
      partnerNotes: values.partnerNotes || null,
      latitude: parseCoord(values.latitude),
      longitude: parseCoord(values.longitude),
      doctor: {
        specialty: {
          id: typeof values.specialty === "string" ? oldDoc.specialty : values.specialty,
        },
        doctorType: values.doctorType,
      },
      email: values.email,
      phoneNumber: values.phone, 
      address: values.address,
      region: {
        id: typeof values.region === "string" ? oldDoc.region : values.region,
      },
      government: {
        id: typeof values.government === "string" ? oldDoc.government : values.government,
      },
    };
    
    dispatch(updatePerson({ personId: id, personData: formattedValues }))
      .unwrap()
      .then(() => {
        toast.success("Médecin modifié avec succès");
        history.push("/médecins");
      })
      .catch((err) => {
        console.error("Erreur mise à jour :", err);
        toast.error("Erreur serveur : " + (err?.message || JSON.stringify(err)));
      });
  };
  
  const onReset = () => {
    form.resetFields();
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier un médecin"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields 
            form={form}
            onAddPartnerNote={handleAddPartnerNote}
            onDeletePartnerNote={handleDeletePartnerNote}
          />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button type="link" htmlType="button" onClick={() => history.push("/médecins")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditDoctorPage;